import { Component } from 'react'
import _ from 'lodash'
import { Modal, Button } from '@vzmi/shp_shared_compo'
import { HyperLink } from '../../../Common/Form'
import { unbindBeforeunload } from '../BeforeUnload'

const LISTING_QUERY_PAGE_URL = '/listing/query'

const redirectToListingQueryPage = id => {
  // proposal form 有設定 post form 如果要離開會有確認視窗，
  // 這裡是使用者確認後會導走不必要再跳提示干擾流程
  unbindBeforeunload()
  // 如果回上一頁要重新確認幫他先塞好賣場調整的 route 才不會因為 compose 頁面導致轉到錯誤頁
  window.history.pushState('', '', `/proposal/updateListingModel?listingId=${id}`)
  window.location.href = LISTING_QUERY_PAGE_URL
}

const ModalFooter = props => (
  <Button
    onClick={() => redirectToListingQueryPage(props.id)}
    data-role='modal-confirm'
    size='large'
  >
    確定
  </Button>
)

const getInvalidMsg = (validation, url) => {
  let Message = null
  switch (true) {
    case validation.isEVoucher: {
      Message = '僅提供非電子票券賣場進行調整。'
      break
    }
    case validation.isInConsistentProductListing: {
      Message = (
        <>
          多個屬性商品規格表不一致，您可至
          <HyperLink
            target='_blank'
            href={url}
          >
            修改賣場規格表
          </HyperLink>
          進行修改後，方可調整此賣場之屬性項目。
        </>
      )
      break
    }
    default:
      break
  }
  return Message
}

class InvalidListingModal extends Component {
  constructor () {
    super()
    this.state = {
      message: null
    }
  }

  componentDidUpdate (prevProps) {
    if (!_.isEqual(prevProps.validation, this.props.validation)) {
      const message = this.getMessage()
      message && this.setState({ message })
    }
  }

  getMessage = () => {
    const {
      listing,
      validation
    } = this.props
    const listingId = _.get(listing, 'id')
    const queryListingUrl = `${LISTING_QUERY_PAGE_URL}?id=${listingId}&idType=listing&page=1`
    const message = getInvalidMsg(validation, queryListingUrl)
    return message
  }

  render () {
    const { message } = this.state
    const {
      visible,
      listing,
      ...restProps
    } = this.props
    const listingId = _.get(listing, 'id')
    return (
      <Modal
        visible={visible}
        className='invalid-listing-modal'
        footer={<ModalFooter id={listingId} />}
        closable={false}
        {...restProps}
      >
        <br />
        {message}
      </Modal>
    )
  }
}

export default InvalidListingModal
